<template>
  <div>
    <OnboardingTextSection>
      Все инструменты автоматического управления<br>
      рекламой собраны во вкладке «Инструменты».<br>
      Каждый из них вы можете изучить по-отдельности.
    </OnboardingTextSection>

    <OnboardingTextSection>
      Именно во вкладке с размещениями происходит<br>
      добавление рекламных кампаний из кабинетов в<br> систему Marilyn.
    </OnboardingTextSection>

    <OnboardingImageSection
      :image="businessMary"
      width="135px"
      align="center"
    />
  </div>
</template>

<script>
  import OnboardingTextSection from 'onboarding/onboardings/components/OnboardingTextSection';
  import OnboardingImageSection from 'onboarding/onboardings/components/OnboardingImageSection';

  import businessMary from 'assets/mascot/business-mary.png';

  export default {
    name: 'InstrumentsInfoStep',
    components: {OnboardingTextSection, OnboardingImageSection},
    data () {
      return {
        businessMary
      };
    }
  };
</script>
